
(function () {
  // console.log('Free Gift Script Loaded');

  let isUpdating = false;
  let isRemovingGiftWrap = false;

  async function checkAndRemoveGiftWrap(cart) {
    const config = window.gift_wrap_config;
    if (!config || isRemovingGiftWrap) return;

    const variantId = parseInt(config.variantId, 10);
    const excludedProductIds = config.excludedProductIds.map(id => parseInt(id, 10));

    // Only act if gift wrap is currently in the cart
    const giftWrapItem = cart.items.find(item => item.variant_id === variantId);
    if (!giftWrapItem) return;

    // Check whether any non-excluded, non-gift-wrap, physical product is in the cart
    // (digital products like the gift card don't require shipping and don't qualify)
    const hasNonExcluded = cart.items.some(item => {
      if (item.variant_id === variantId) return false;
      if (!item.requires_shipping) return false;
      if (excludedProductIds.includes(item.product_id)) return false;
      return true;
    });

    if (!hasNonExcluded) {
      try {
        isRemovingGiftWrap = true;
        const updates = {};
        updates[giftWrapItem.key] = 0;
        await updateCart(updates);
        const updatedCart = await getCart();
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          bubbles: true,
          detail: { cart: updatedCart, cartCount: updatedCart.item_count }
        }));
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      } catch (e) {
        console.error('Gift wrap removal error:', e);
      } finally {
        isRemovingGiftWrap = false;
      }
    }
  }

  function getGiftConfig() {
    if (window.min_gift) {
      return window.min_gift;
    }
    console.warn('Free gift configuration (window.min_gift) is missing. Check theme.liquid.');
    return null;
  }

  async function getCart() {
    const response = await fetch('/cart.js', { cache: 'no-store' });
    if (!response.ok) throw new Error('Failed to fetch cart');
    return await response.json();
  }

  async function addFilesToCart(items) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!response.ok) throw new Error('Failed to add gift');
    return await response.json();
  }

  async function updateCart(updates) {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    if (!response.ok) throw new Error('Failed to update cart');
    return await response.json();
  }

  function isFreeGiftItem(item) {
    return item.properties && item.properties._free_gift === "true";
  }

  function isGiftCardItem(item) {
    return item.gift_card === true || (item.product_title && item.product_title.toLowerCase() === 'digital cou cou gift card');
  }

  function computeEligibility(cart, config) {
    const { min_price, excluded_ids, included_ids } = config;
    let eligibleTotal = 0;
    let hasEligibleItems = false;

    if (included_ids && included_ids.length > 0) {
      eligibleTotal = cart.items.reduce((total, item) => {
        if (isFreeGiftItem(item)) return total;
        if (included_ids.includes(item.product_id)) {
          hasEligibleItems = true;
          return total + item.final_line_price;
        }
        return total;
      }, 0);
    } else {
      let giftCardEligibleTotal = 0;
      eligibleTotal = cart.items.reduce((total, item) => {
        if (isFreeGiftItem(item)) return total;
        if (isGiftCardItem(item)) {
          giftCardEligibleTotal += item.final_line_price;
          return total;
        }
        if (excluded_ids.includes(item.product_id)) return total;
        hasEligibleItems = true;
        return total + item.final_line_price;
      }, 0);
      if (hasEligibleItems) eligibleTotal += giftCardEligibleTotal;
    }

    return {
      eligibleTotal,
      hasEligibleItems,
      isEligible: hasEligibleItems && eligibleTotal >= min_price
    };
  }

  const GIFT_DISMISS_KEY = 'cc_gift_dismissed_total';

  function getDismissedGiftTotal() {
    const raw = sessionStorage.getItem(GIFT_DISMISS_KEY);
    return raw === null ? null : parseFloat(raw);
  }

  function setDismissedGiftTotal(total) {
    sessionStorage.setItem(GIFT_DISMISS_KEY, String(total));
  }

  function clearDismissedGiftTotal() {
    sessionStorage.removeItem(GIFT_DISMISS_KEY);
  }

  function hasGiftInCart(cart, config) {
    return cart.items.some(item =>
      (item.variant_id === config.main_gift.id || item.variant_id === config.fallback_gift.id) && isFreeGiftItem(item)
    );
  }

  let lastCartHadGift = false;

  async function removeGifts(cart, main_gift, fallback_gift) {

    const giftItems = cart.items.filter(item => {
      const isGiftVariant = item.variant_id === main_gift.id || item.variant_id === fallback_gift.id;
      return isGiftVariant && isFreeGiftItem(item);
    });

    if (giftItems.length === 0) return;

   
    const updates = {};
    giftItems.forEach(item => {
      updates[item.key] = 0;
    });

    // console.log('Removing free gifts only:', updates);
    await updateCart(updates);
    const updatedCart = await getCart();
    document.dispatchEvent(new CustomEvent('theme:cart:change', {
      bubbles: true,
      detail: {
        cart: updatedCart,
        cartCount: updatedCart.item_count
      }
    }));
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', {
      bubbles: true
    }));
  }

  async function checkFreeGift() {
    if (isUpdating) return;

    const config = getGiftConfig();
    if (!config) return;

    try {
      isUpdating = true;
      const cart = await getCart();
      const { enabled, min_price, main_gift, fallback_gift, excluded_ids, included_ids } = config;

      // If free gift is disabled, don't add gift
      if (!enabled) {
        return;
      }
      // If there's no gift configured or threshold is not set, we don't need to do anything
      if (min_price === null || ((!main_gift.id || main_gift.id === 0) && (!fallback_gift.id || fallback_gift.id === 0))) {
        return;
      }

      // console.log('Free Gift Check:', {
      //   cartTotal: cart.total_price,
      //   minPrice: min_price,
      //   mainGift: main_gift,
      //   fallbackGift: fallback_gift,
      //   excludedCount: excluded_ids.length,
      //   includedCount: included_ids.length
      // });


      const { eligibleTotal, isEligible } = computeEligibility(cart, config);

      // console.log(`Eligible Total: ${eligibleTotal}, Required: ${min_price}`);

      if (isEligible) {
        const hasMain = cart.items.some(item => item.variant_id === main_gift.id && isFreeGiftItem(item));
        const hasFallback = cart.items.some(item => item.variant_id === fallback_gift.id && isFreeGiftItem(item));

        if (hasMain || hasFallback) {
          // console.log('Gift already in cart.');
          return;
        }

        // User manually removed the gift earlier and hasn't added enough to earn it again — respect that choice
        const dismissedTotal = getDismissedGiftTotal();
        if (dismissedTotal !== null && eligibleTotal <= dismissedTotal) {
          return;
        }
        if (dismissedTotal !== null) clearDismissedGiftTotal();

        let giftToAdd = null;
        if (main_gift.available && main_gift.id !== 0) {
          giftToAdd = main_gift;
        } else if (fallback_gift.available && fallback_gift.id !== 0) {
          giftToAdd = fallback_gift;
        }

        if (giftToAdd) {
          console.log('Adding gift:');
          await addFilesToCart([
            {
              id: giftToAdd.id,
              quantity: 1,
              properties: {
                "_free_gift": "true"
              }
            }
          ]);

          const cart = await getCart();
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            bubbles: true,
            detail: {
              cart: cart,
              cartCount: cart.item_count
            }
          }));
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', {
            bubbles: true
          }));
        } else {
          // console.warn('No valid gift available to add (Main and Fallback unavailable or not configured).');
        }

      } else {

        // console.log('Not eligible. Removing any existing gifts.');
        clearDismissedGiftTotal();
        await removeGifts(cart, main_gift, fallback_gift);
      }

    } catch (e) {
      console.error('Free Gift Logic Error:', e);
    } finally {
      isUpdating = false;
    }
  }


  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  function updateTieredProgressBar(e) {
    const progressBar = document.querySelector('.tiered-progress-bar');
    if (!progressBar) return;

    const cart = e.detail.cart;
    if (!cart) return;

    // Check if both gift options are unavailable
    const config = getGiftConfig();

    // Resolve include/exclude lists once — used for shipping, gift, and bar visibility
    const { excluded_ids = [], included_ids = [] } = (config || {});
    const itemCounts = (item) => {
      if (isFreeGiftItem(item)) return false;
      if (isGiftCardItem(item)) return false;
      if (included_ids.length > 0) return included_ids.includes(item.product_id);
      return !excluded_ids.includes(item.product_id);
    };

    // Shipping total: only qualifying (non-excluded) products; gift cards tracked separately
    let giftCardLineTotal = 0;
    let shippingCartTotal = cart.items.reduce((total, item) => {
      if (isFreeGiftItem(item)) return total;
      if (isGiftCardItem(item)) {
        giftCardLineTotal += item.final_line_price;
        return total;
      }
      if (!itemCounts(item)) return total;
      return total + item.final_line_price;
    }, 0);

    // Hide bar entirely if cart has no qualifying items (only gift cards / free gifts / excluded products)
    const hasNonGiftCardItems = cart.items.some(item => itemCounts(item));
    const freeShippingContainer = progressBar.closest('.free-shipping');
    if (!hasNonGiftCardItems) {
      progressBar.style.display = 'none';
      if (freeShippingContainer) freeShippingContainer.style.display = 'none';
      return;
    } else {
      progressBar.style.display = '';
      if (freeShippingContainer) freeShippingContainer.style.display = '';
      // Real qualifying products exist — include gift card price in shipping total
      shippingCartTotal += giftCardLineTotal;
    }

    // Gift total: apply include/exclude lists
    let giftCartTotal = 0;
    if (config) {
      const { excluded_ids = [], included_ids = [] } = config;

      if (included_ids.length > 0) {
        // Only count included products
        giftCartTotal = cart.items.reduce((total, item) => {
          if (isFreeGiftItem(item)) return total;
          if (isGiftCardItem(item)) return total;
          if (included_ids.includes(item.product_id)) {
            return total + item.final_line_price;
          }
          return total;
        }, 0);
      } else {
        // Count all products except excluded ones and gift cards
        giftCartTotal = cart.items.reduce((total, item) => {
          if (isFreeGiftItem(item)) return total;
          if (isGiftCardItem(item)) return total;
          if (excluded_ids.includes(item.product_id)) return total;
          return total + item.final_line_price;
        }, 0);
      }
    } else {
      giftCartTotal = shippingCartTotal;
    }

    // Include gift card price in gift total when real products are present
    giftCartTotal += giftCardLineTotal;

    // Use shipping total for progress fill; gift total for gift milestone
    const cartTotal = shippingCartTotal;

    const maxLimitStr = progressBar.getAttribute('data-max-limit');
    const shippingLimitStr = progressBar.getAttribute('data-shipping-limit');
    const giftLimitStr = progressBar.getAttribute('data-gift-limit');

    if (maxLimitStr === null || maxLimitStr === "") return;

    const maxLimit = parseInt(maxLimitStr);
    const shippingLimit = (shippingLimitStr !== null && shippingLimitStr !== "") ? parseInt(shippingLimitStr) : null;
    const giftLimit = (giftLimitStr !== null && giftLimitStr !== "") ? parseInt(giftLimitStr) : null;
    const bothGiftsUnavailable = config &&
      !config.main_gift.available &&
      !config.fallback_gift.available;

    // Read shipping/gift enabled flags from label data attributes
    const label = progressBar.querySelector('[data-tiered-label]');
    const shippingEnabled = label ? label.dataset.shippingEnabled === 'true' : false;
    const giftEnabledRaw = label ? label.dataset.giftEnabled === 'true' : false;

    // If both gifts unavailable and shipping is not enabled, hide entire progress bar
    if (bothGiftsUnavailable && !shippingEnabled) {
      progressBar.style.display = 'none';
      return;
    } else {
      progressBar.style.display = '';
    }

    // Hide gift milestone if both gifts are unavailable
    const giftMilestoneElement = progressBar.querySelector('.milestone--gift');
    if (giftMilestoneElement) {
      if (bothGiftsUnavailable) {
        giftMilestoneElement.style.display = 'none';
      } else {
        giftMilestoneElement.style.display = '';
      }
    }

    // Recalculate max limit if gift milestone is hidden
    let effectiveMaxLimit = maxLimit;
    if (bothGiftsUnavailable && shippingLimit !== null) {
      effectiveMaxLimit = shippingLimit;
    }

    const giftEnabledForBar = giftEnabledRaw && !bothGiftsUnavailable;
    const bothTiersActive = shippingEnabled && giftEnabledForBar && shippingLimit && giftLimit && shippingLimit !== giftLimit;

    let percentage;
    if (bothTiersActive) {
      // Piecewise fill: smaller milestone pinned at 50%, bar capped there until that tier is met
      if (shippingLimit < giftLimit) {
        // Shipping is first tier (milestone at 50%)
        if (cartTotal < shippingLimit) {
          percentage = (cartTotal * 50) / shippingLimit;
        } else {
          const phase2Progress = Math.min(cartTotal, giftLimit) - shippingLimit;
          const phase2Range = giftLimit - shippingLimit;
          percentage = 50 + (phase2Progress * 50) / phase2Range;
        }
      } else {
        // Gift is first tier (milestone at 50%)
        if (giftCartTotal < giftLimit) {
          percentage = (giftCartTotal * 50) / giftLimit;
        } else {
          const phase2Progress = Math.min(giftCartTotal, shippingLimit) - giftLimit;
          const phase2Range = shippingLimit - giftLimit;
          percentage = 50 + (phase2Progress * 50) / phase2Range;
        }
      }
    } else {
      percentage = effectiveMaxLimit > 0 ? (cartTotal * 100) / effectiveMaxLimit : 100;
    }
    if (percentage > 100) percentage = 100;

    const fill = progressBar.querySelector('.tiered-progress-bar__fill');
    if (fill) {
      fill.style.width = `${percentage}%`;
    }

    const shippingMilestoneContainer = progressBar.querySelector('.milestone--shipping');
    const shippingMilestone = shippingMilestoneContainer?.querySelector('.milestone-dot');
    if (shippingMilestoneContainer && shippingMilestone) {
      // Reposition shipping milestone to 100% if gift is hidden and shipping is the max
      if (bothGiftsUnavailable && shippingLimit === effectiveMaxLimit) {
        shippingMilestoneContainer.style.left = '100%';
      } else if (!giftMilestoneElement || giftMilestoneElement.style.display === 'none') {
        // Gift milestone is not visible — shipping is the only one, position at 100%
        shippingMilestoneContainer.style.left = '100%';
      } else {
        // Both milestones visible — pin smaller threshold at 50%
        if (bothTiersActive) {
          shippingMilestoneContainer.style.left = shippingLimit < giftLimit ? '50%' : `${maxLimit > 0 ? (shippingLimit * 100) / maxLimit : 100}%`;
        } else {
          const originalPosition = shippingLimit !== null && maxLimit > 0 ? (shippingLimit * 100) / maxLimit : 100;
          shippingMilestoneContainer.style.left = `${originalPosition}%`;
        }
      }
      if (shippingLimit !== null && cartTotal >= shippingLimit) {
        shippingMilestone.classList.add('active');
      } else {
        shippingMilestone.classList.remove('active');
      }
    }

    // Only update gift milestone if gifts are available
    if (!bothGiftsUnavailable) {
      const giftMilestoneContainer = progressBar.querySelector('.milestone--gift');
      const giftMilestone = giftMilestoneContainer?.querySelector('.milestone-dot');
      if (giftMilestoneContainer && giftMilestone) {
        // Pin gift milestone at 50% when gift is the smaller (first) tier
        if (bothTiersActive && giftLimit < shippingLimit) {
          giftMilestoneContainer.style.left = '50%';
        }
        if (giftCartTotal >= giftLimit) {
          giftMilestone.classList.add('active');
        } else {
          giftMilestone.classList.remove('active');
        }
      }
    }

    // Update dynamic label
    if (label) {
      const giftEnabled = giftEnabledForBar;

      const shippingAchieved = shippingEnabled && cartTotal >= shippingLimit;
      const giftAchieved = giftEnabled && giftCartTotal >= giftLimit;

      const shippingRemaining = shippingLimit - cartTotal;
      const giftRemaining = giftLimit - giftCartTotal;

      const formatMoney = (cents) => {
        if (typeof window.theme !== 'undefined' && window.theme.formatMoney) {
          return window.theme.formatMoney(cents, theme.moneyFormat).replace(/\.00$/, '');
        }
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          return Shopify.formatMoney(cents).replace(/\.00$/, '');
        }
        const amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
        const format = (typeof theme !== 'undefined' && theme.moneyFormat) ? theme.moneyFormat : '${{amount}}';
        return format.replace(/\{\{\s*amount\s*\}\}/, amount);
      };

      // Get messages from data attributes
      const msgBoth = label.dataset.msgBoth || '';
      const msgShippingAchieved = label.dataset.msgShippingAchieved || '';
      const msgGiftAchieved = label.dataset.msgGiftAchieved || '';
      const msgOnlyShippingAchieved = label.dataset.msgOnlyShippingAchieved || '';
      const msgOnlyGiftAchieved = label.dataset.msgOnlyGiftAchieved || '';
      const msgAwayBoth = label.dataset.msgAwayBoth || '';
      const msgAwayShipping = label.dataset.msgAwayShipping || '';
      const msgAwayGift = label.dataset.msgAwayGift || '';
      const minPriceGift = window.min_gift.min_price;
      const minPriceShip = window.min_gift.ship_min_price


      //  console.log(window.min_gift.min_price, "gift price and shiping" , window.min_gift.ship_min_price);

      let labelText = '';

      // console.log(minPriceGift,'minPriceGift');
      // console.log(minPriceShip,'minPriceShip');
  
      if (shippingEnabled && giftEnabled && shippingAchieved && giftAchieved  && minPriceGift !== null && minPriceShip !== null ) {
        // console.log('ship 1');
        
        labelText = msgBoth;
      } else if (shippingEnabled && shippingAchieved && giftEnabled && !giftAchieved  && minPriceGift !== null && minPriceShip !== null ) {
        // console.log('ship 2');
        labelText = msgShippingAchieved.replace('||gift_amount||', formatMoney(giftRemaining));
      } else if (giftEnabled && giftAchieved && shippingEnabled && !shippingAchieved && minPriceGift !== null && minPriceShip !== null ) {

        // console.log('ship 3');
        labelText = msgGiftAchieved.replace('||shipping_amount||', formatMoney(shippingRemaining));
      } else if (shippingEnabled && shippingAchieved && !giftEnabled && minPriceShip !== null) {

        // console.log('ship 4');
        labelText = msgOnlyShippingAchieved;
      } else if (giftEnabled && giftAchieved && !shippingEnabled  && minPriceGift !== null ) {
        // console.log('ship 5');
        labelText = msgOnlyGiftAchieved;
      } else if (shippingEnabled && giftEnabled && minPriceShip !== null && minPriceGift !== null) {
        // console.log('ship 6');
        labelText = msgAwayBoth
          .replace('||shipping_amount||', formatMoney(shippingRemaining))
          .replace('||gift_amount||', formatMoney(giftRemaining));
      } else if (shippingEnabled && minPriceShip !== null && !shippingAchieved) {
        // console.log('ship 7');
        labelText = msgAwayShipping.replace('||shipping_amount||', formatMoney(shippingRemaining));
      }
      else if (shippingEnabled && shippingAchieved && minPriceShip !== null) {
      // console.log('ship 71');
        labelText = msgOnlyShippingAchieved;

      }
       else if (giftEnabled && minPriceGift !== null && !shippingEnabled) {
        //  console.log('ship 8');
        labelText = msgAwayGift.replace('||gift_amount||', formatMoney(giftRemaining));
      } else if (shippingEnabled && !giftAchieved && minPriceShip === null) {
        //  console.log('ship 9');
        labelText = msgAwayGift.replace('||gift_amount||', formatMoney(giftRemaining));

      } else if (shippingEnabled && giftAchieved && minPriceShip === null && giftEnabled && minPriceGift !== null) {
        // console.log('ship 10');
        labelText = msgOnlyGiftAchieved;
      } else if (giftEnabled && !shippingAchieved && minPriceGift === null) {
        //  console.log('ship 11');
        labelText = msgAwayShipping.replace('||shipping_amount||', formatMoney(shippingRemaining));
      } else if (giftEnabled && shippingAchieved && minPriceGift === null) {
        //  console.log('ship 12');
        labelText = msgOnlyShippingAchieved;
      }

      label.textContent = labelText;
    }
  }

  const debouncedCheck = debounce(checkFreeGift, 500);
  function initUpsellGridSlider() {
    try {
      const upsellHolder = document.querySelector('[data-upsell-products]');
      const gridSlider = upsellHolder ? upsellHolder.closest('grid-slider') : null;
      if (gridSlider) {
        gridSlider.dispatchEvent(new CustomEvent('theme:grid-slider:init', { bubbles: true }));
      }
    } catch (err) {}
  }

  document.addEventListener('theme:cart:change', async (e) => {
    let cart = e.detail ? e.detail.cart : null;
    if (!cart) {
        try {
            cart = await getCart();
        } catch (error) {
            console.error('Error fetching cart for progress bar:', error);
            return;
        }
    }

    const config = getGiftConfig();
    if (config && config.enabled) {
      const hasGiftNow = hasGiftInCart(cart, config);
      if (lastCartHadGift && !hasGiftNow) {
        // Gift was in the cart on the last change and is gone now — user removed it manually.
        // Remember the eligible total at that point so we don't immediately re-add it.
        const { eligibleTotal } = computeEligibility(cart, config);
        setDismissedGiftTotal(eligibleTotal);
      }
      lastCartHadGift = hasGiftNow;
    }

    debouncedCheck(e);

    updateTieredProgressBar({ detail: { cart: cart } });
    initUpsellGridSlider();
    await checkAndRemoveGiftWrap(cart);
  });
  document.addEventListener('theme:cart:add', debouncedCheck);
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(checkFreeGift, 500);
    getCart().then(cart => {
      const config = getGiftConfig();
      if (config) lastCartHadGift = hasGiftInCart(cart, config);
    }).catch(() => {});
    initUpsellGridSlider();

    // Hide progress bar on initial load if gifts unavailable and shipping disabled
    const progressBar = document.querySelector('.tiered-progress-bar');
    if (progressBar) {
      const config = getGiftConfig();
      const bothGiftsUnavailable = config && !config.main_gift.available && !config.fallback_gift.available;
      if (bothGiftsUnavailable) {
        const label = progressBar.querySelector('[data-tiered-label]');
        const shippingEnabled = label ? label.dataset.shippingEnabled === 'true' : false;
        if (!shippingEnabled) {
          progressBar.style.display = 'none';
        }
      }
    }
  });
  document.addEventListener('theme:cart:refresh', initUpsellGridSlider);
  document.addEventListener('theme:cart-drawer:open', initUpsellGridSlider);

  // Gift Wrap Logic
  document.addEventListener('change', async function(e) {
    if (e.target && e.target.matches('[data-gift-wrap-checkbox]')) {
        const variantId = e.target.getAttribute('data-variant-id');
        const isChecked = e.target.checked;
        const wrapper = e.target.closest('.cart__gift-wrap-checkbox-wrapper');
        
        if (wrapper) wrapper.classList.add('loading');
        
        try {
            if (isChecked) {
                await addFilesToCart([{
                    id: variantId,
                    quantity: 1
                }]);
            } else {
                const updates = {};
                updates[variantId] = 0;
                await updateCart(updates);
            }
            
             const cart = await getCart();
             
             document.dispatchEvent(new CustomEvent('theme:cart:change', {
                bubbles: true,
                detail: { 
                    cart: cart,
                    cartCount: cart.item_count 
                }
            }));
            
             document.dispatchEvent(new CustomEvent('theme:cart:refresh', {
                bubbles: true
            }));

        } catch (error) {
            console.error('Error updating gift wrap:', error);
            e.target.checked = !isChecked; // Revert
        } finally {
             if (wrapper) wrapper.classList.remove('loading');
        }
    }
  });

  function hideUpsellAddedItems(cart) {
    try {
      const cartProductIds = (cart?.items || []).map((it) => it.product_id);
      const holders = document.querySelectorAll('[data-quick-add-holder]');
      holders.forEach((el) => {
        const pid = parseInt(el.getAttribute('data-quick-add-holder'));
        const quickAddProduct = el.closest('quick-add-product');
        if (!quickAddProduct) return;
        if (cartProductIds.includes(pid)) {
          quickAddProduct.classList.add('hidden');
        } else {
          quickAddProduct.classList.remove('hidden');
        }
      });
      const upsellHolder = document.querySelector('[data-upsell-products]');
      const gridSlider = upsellHolder ? upsellHolder.closest('grid-slider') : null;
      if (gridSlider) {
        gridSlider.dispatchEvent(new CustomEvent('theme:grid-slider:init', { bubbles: true }));
      }
    } catch (err) {}
  }

  document.addEventListener('theme:product:added', async () => {
    try {
      const cart = await getCart();
      hideUpsellAddedItems(cart);
    } catch (err) {}
  });

  document.addEventListener('theme:cart:change', async (e) => {
    if (e?.detail?.cart) hideUpsellAddedItems(e.detail.cart);
    else {
      try {
        const cart = await getCart();
        hideUpsellAddedItems(cart);
      } catch (err) {}
    }
  });

    class VariantSelectionValidator {
    constructor() {
      this.selectors = {
        productSection: '[data-section-type="product"]',
        quickAddModal: '[data-quick-add-modal]',
        variantSelectors: '[data-product-variants]',
        selectorWrapper: '.selector-wrapper',
        addToCartBtn: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
        sizeValueLabel: '[data-size-value]',
        variantIdInput: '[data-variant-id-input], input[name="id"]',
        optionInput: '[data-single-option-selector]',
        productForm: '[data-product-form]',
        radioButton: '.radio__button input[type="radio"]',
        swatchButton: '.swatch__button input[type="radio"]',
        popoutInput: '[data-popout-input]',
        notifyMeBtn: '.product-soldout-notification button[data-popup-open]',
        swymNotifyBtn: '.swym-custom-bis-form__submit'
      };

      this.classes = {
        shakeError: 'shake-error',
        needsSelection: 'needs-selection',
        sizeError: 'radio__legend__value--error',
        allVariantsSoldOut: 'all-variants--soldout'
      };

      this.init();
    }

    init() {
      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }

    setup() {
      // Find all product sections
      const productSections = document.querySelectorAll(this.selectors.productSection);
      productSections.forEach(section => this.initProductSection(section));

      // Also handle dynamically added product forms (quick view, etc.)
      this.observeNewProducts();
    }

    initProductSection(section) {
      const variantSelectors = section.querySelector(this.selectors.variantSelectors);
      const addToCartBtn = section.querySelector(this.selectors.addToCartBtn);
      const productForm = section.querySelector(this.selectors.productForm);
      const notifyMeBtn = section.querySelector(this.selectors.notifyMeBtn);
      const swymNotifyBtns = section.querySelectorAll(this.selectors.swymNotifyBtn);

      if (!variantSelectors || !addToCartBtn) return;

      // Check if product has variants (not just default variant)
      const optionsCount = parseInt(variantSelectors.dataset.optionsCount, 10) || 0;
      const variantSelected = variantSelectors.dataset.variantSelected === 'true';

      if (optionsCount === 0) return; // No variants to select

      // Get size error text from data attribute
      const sizeErrorText = variantSelectors.dataset.sizeErrorText || 'PLEASE SELECT A SIZE';
      const sizeValueLabel = variantSelectors.querySelector(this.selectors.sizeValueLabel);

      // Clear any auto-filled values when no variant is pre-selected
      // Theme JS may auto-fill these, so we need to clear them after theme initializes
      if (!variantSelected) {
        const clearAutoFilledValues = () => {
          const noInitialValueLabels = variantSelectors.querySelectorAll('[data-no-initial-value="true"]');
          noInitialValueLabels.forEach(label => {
            const wrapper = label.closest(this.selectors.selectorWrapper);
            const hasCheckedInput = wrapper?.querySelector('input[type="radio"]:checked');
            if (!hasCheckedInput) {
              label.textContent = '';
            }
          });
        };
        // Clear immediately
        clearAutoFilledValues();
        // Clear again after theme JS runs
        setTimeout(clearAutoFilledValues, 100);
        setTimeout(clearAutoFilledValues, 300);
      }

      // Store references
      const state = {
        section,
        variantSelectors,
        addToCartBtn,
        productForm,
        notifyMeBtn,
        swymNotifyBtns,
        optionsCount,
        variantSelected,
        selectedOptions: new Set(),
        sizeValueLabel,
        sizeErrorText,
        originalSizeValue: ''
      };

      // Check initial selection state
      this.checkInitialSelections(state);

      // If no variant pre-selected, set up validation
      if (!variantSelected && state.selectedOptions.size < optionsCount) {
        this.setupValidation(state);
      }

      // Listen for option changes
      this.listenForOptionChanges(state);

      // Keep ATC visible when selection is incomplete
      if (!variantSelected) {
        this.updateButtonState(state);
        setTimeout(() => this.updateButtonState(state), 0);
      }
    }

    checkInitialSelections(state) {
      const { variantSelectors } = state;
      const selectorWrappers = variantSelectors.querySelectorAll(this.selectors.selectorWrapper);

      selectorWrappers.forEach((wrapper, index) => {
        const checkedInput = wrapper.querySelector('input[type="radio"]:checked');
        const popoutInput = wrapper.querySelector(this.selectors.popoutInput);

        // Check radio buttons
        if (checkedInput) {
          state.selectedOptions.add(index);
        }

        // Check popout selects (dropdowns)
        if (popoutInput && popoutInput.value && popoutInput.value.trim() !== '') {
          state.selectedOptions.add(index);
        }
      });
    }

    setupValidation(state) {
      const { addToCartBtn, section, notifyMeBtn, swymNotifyBtns } = state;

      // Intercept add to cart click
      addToCartBtn.addEventListener('click', (e) => {
        if (!this.areAllOptionsSelected(state)) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          this.showValidationError(state);
          return false;
        }
      }, true); // Use capture phase to intercept before other handlers

      // Intercept notify me click
      if (notifyMeBtn) {
        notifyMeBtn.addEventListener('click', (e) => {
          if (!this.areAllOptionsSelected(state)) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            this.showValidationError(state);
            return false;
          }
        }, true);
      }

      // Intercept the Swym "back in stock" notify click (products where all
      // variants are sold out) the same way as add to cart / notify me above,
      // so it gets the same required-selection error and shake effect and never
      // reaches Swym without a real variant selected.
      if (swymNotifyBtns && swymNotifyBtns.length) {
        swymNotifyBtns.forEach((swymBtn) => {
          swymBtn.addEventListener('click', (e) => {
            if (!this.areAllOptionsSelected(state)) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              this.showValidationError(state);
              return false;
            }
          }, true);
        });
      }

      // Also intercept form submission
      const form = section.querySelector('form[data-product-form]');
      if (form) {
        form.addEventListener('submit', (e) => {
          if (!this.areAllOptionsSelected(state)) {
            e.preventDefault();
            e.stopPropagation();
            this.showValidationError(state);
            return false;
          }
        }, true);
      }
    }

    listenForOptionChanges(state) {
      const { variantSelectors, section } = state;

      // Listen for radio button changes
      variantSelectors.addEventListener('change', (e) => {
        const target = e.target;
        if (target.matches('input[type="radio"]') || target.matches(this.selectors.popoutInput)) {
          this.handleOptionChange(state, target);
        }
      });

      // Listen for popout option clicks (for dropdown selects)
      variantSelectors.addEventListener('click', (e) => {
        const popoutOption = e.target.closest('[data-popout-option]');
        if (popoutOption) {
          // Small delay to let the popout update the hidden input
          setTimeout(() => {
            const wrapper = popoutOption.closest(this.selectors.selectorWrapper);
            if (wrapper) {
              const index = this.getWrapperIndex(state, wrapper);
              state.selectedOptions.add(index);
              this.updateButtonState(state);
              this.hideError(state);
              wrapper.classList.remove(this.classes.needsSelection);
              if (this.areAllOptionsSelected(state)) {
                this.markVariantSelected(state);
              }
            }
          }, 50);
        }
      });
    }

    handleOptionChange(state, input) {
      const wrapper = input.closest(this.selectors.selectorWrapper);
      if (!wrapper) return;

      const index = this.getWrapperIndex(state, wrapper);
      state.selectedOptions.add(index);

      // Update UI
      this.updateButtonState(state);
      this.hideError(state);
      wrapper.classList.remove(this.classes.needsSelection);
      if (this.areAllOptionsSelected(state)) {
        this.markVariantSelected(state);
      }

      // If not all options are selected yet, clear labels for unselected options
      // and remove the ?variant= URL param that theme.js added prematurely.
      // Our listener is on the parent (event delegation) so it runs after theme.js's
      // listener on the radio input — no setTimeout needed, no visible flash.
      if (!this.areAllOptionsSelected(state)) {
        const selectorWrappers = state.variantSelectors.querySelectorAll(this.selectors.selectorWrapper);
        selectorWrappers.forEach((w, i) => {
          if (!state.selectedOptions.has(i)) {
            const label = w.querySelector('[data-no-initial-value]');
            if (label) label.textContent = '';
          }
        });

        // Remove ?variant= from URL — theme.js sets it based on the first matching
        // variant even when size isn't chosen yet, so we strip it here.
        const url = new URL(window.location.href);
        if (url.searchParams.has('variant')) {
          url.searchParams.delete('variant');
          window.history.replaceState({path: url.toString()}, '', url.toString());
        }
      }
    }

    markVariantSelected(state) {
      const { variantSelectors } = state;
      if (!variantSelectors) return;
      if (variantSelectors.dataset.variantSelected === 'true') return;
      variantSelectors.dataset.variantSelected = 'true';
      state.variantSelected = true;
    }

    getWrapperIndex(state, wrapper) {
      const wrappers = state.variantSelectors.querySelectorAll(this.selectors.selectorWrapper);
      return Array.from(wrappers).indexOf(wrapper);
    }

    areAllOptionsSelected(state) {
      return state.selectedOptions.size >= state.optionsCount;
    }

    showValidationError(state) {
      const { variantSelectors, sizeValueLabel, sizeErrorText } = state;

      const selectorWrappers = variantSelectors.querySelectorAll(this.selectors.selectorWrapper);
      const sizeWrapper = variantSelectors.querySelector('.selector-wrapper--size');
      const sizeIndex = sizeWrapper ? Array.from(selectorWrappers).indexOf(sizeWrapper) : -1;
      const unselectedWrappers = [];

      selectorWrappers.forEach((wrapper, index) => {
        if (!state.selectedOptions.has(index)) {
          wrapper.classList.add(this.classes.needsSelection);
          unselectedWrappers.push(wrapper);

          // Shake all unselected wrappers
          wrapper.classList.add(this.classes.shakeError);

          if (index === sizeIndex) {
            // Size: show error message below size selector
            const sizeErrorDiv = wrapper.querySelector('[data-size-error]');
            if (sizeErrorDiv) {
              sizeErrorDiv.style.display = 'block';
            }
            // Also add error class to size label
            if (sizeValueLabel) {
              sizeValueLabel.classList.add(this.classes.sizeError);
            }
          } else {
            // Other options (fabric etc): error text in their data-option-value label
            const optionLabel = wrapper.querySelector('[data-option-value]');
            const optionName = wrapper.querySelector('.radio__legend__option-name')?.textContent?.replace(':', '').trim() || 'OPTION';
            if (optionLabel) {
              optionLabel.textContent = `PLEASE SELECT A ${optionName.toUpperCase()}`;
              optionLabel.classList.add(this.classes.sizeError);
            }
          }
        }
      });

      // Remove shake from all unselected wrappers after animation
      setTimeout(() => {
        unselectedWrappers.forEach(w => w.classList.remove(this.classes.shakeError));
      }, 600);

      // Scroll to first unselected option on mobile
      if (window.innerWidth < 768 && unselectedWrappers.length > 0) {
        unselectedWrappers[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    hideError(state) {
      const { variantSelectors, sizeValueLabel } = state;

      // Hide size error message div
      const sizeErrorDiv = variantSelectors?.querySelector('[data-size-error]');
      if (sizeErrorDiv) {
        sizeErrorDiv.style.display = 'none';
      }

      // Clear size error
      if (sizeValueLabel && sizeValueLabel.classList.contains(this.classes.sizeError)) {
        sizeValueLabel.classList.remove(this.classes.sizeError);
      }

      // Remove error styling from all other option labels
      // Do NOT clear textContent — theme.js updateLegend() has already set it to the selected value
      variantSelectors?.querySelectorAll(`[data-option-value].${this.classes.sizeError}`).forEach(label => {
        label.classList.remove(this.classes.sizeError);
      });
    }

    setNeedsSelectionButtonState(state) {
      const { addToCartBtn, section } = state;
      const addToCartText = addToCartBtn.querySelector(this.selectors.addToCartText);
      const formWrapper = section.querySelector('[data-form-wrapper]');
      const hasAllVariantsSoldOut = formWrapper?.classList.contains(this.classes.allVariantsSoldOut);

      if (hasAllVariantsSoldOut) {
        return;
      }

      addToCartBtn.removeAttribute('disabled');
      addToCartBtn.setAttribute('data-requires-variant-selection', 'true');

      if (addToCartText) {
        addToCartText.innerHTML = window.theme?.strings?.addToCart || 'Add to cart';
      }

      if (formWrapper) {
        formWrapper.classList.remove('variant--soldout', 'variant--unavailable');
      }
    }

    updateButtonState(state) {
      const { addToCartBtn, section } = state;

      if (!this.areAllOptionsSelected(state)) {
        this.setNeedsSelectionButtonState(state);
        return;
      }

      if (this.areAllOptionsSelected(state)) {
        // Get the variant ID input to check availability
        const variantIdInput = section.querySelector(this.selectors.variantIdInput);
        const variantId = variantIdInput?.value;

        // Check if variant is available (the product form component handles this)
        // We just enable the button here - the existing variant change logic handles sold out state
        if (variantId && variantId !== '') {
          // Let the existing theme code handle the button state based on variant availability
          // We just remove our "requires selection" state
          addToCartBtn.removeAttribute('data-requires-variant-selection');

          // Trigger a change event to let the theme update the button
          if (variantIdInput) {
            variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    }

    observeNewProducts() {
      // Use MutationObserver to handle dynamically added product forms
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              const productSection = node.matches?.(this.selectors.productSection)
                ? node
                : node.querySelector?.(this.selectors.productSection);

              if (productSection) {
                this.initProductSection(productSection);
              }

              // Also check for quick add modals
              const quickAddModal = node.matches?.(this.selectors.quickAddModal)
                ? node
                : node.querySelector?.(this.selectors.quickAddModal);

              if (quickAddModal) {
                this.initProductSection(quickAddModal);
              }
            }
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  // Initialize the validator
  new VariantSelectionValidator();

  // Toggle popup trigger on sold-out variant changes
  (function() {
    const selectors = {
      productSection: '[data-section-type="product"]',
      quickAddModal: '[data-quick-add-modal]',
      productJson: '[data-product-json]',
      variantIdInput: '[data-variant-id-input], input[name="id"]',
      notifyButton: '.product-soldout-notification button'
    };

    const updateNotifyPopupTrigger = (section, variant) => {
      if (!section) return;
      const notifyButton = section.querySelector(selectors.notifyButton);
      if (!notifyButton) return;

      if (variant && variant.available === false) {
        // notifyButton.setAttribute('data-popup-open', '');

        if (!notifyButton.__popupOpenHandler) {
          notifyButton.__popupOpenHandler = (e) => {
            const popupComponent = notifyButton.closest('popup-component');
            if (!popupComponent || typeof popupComponent.popupOpen !== 'function') return;
            e.preventDefault();
            // popupComponent.popupOpen();
          };
          notifyButton.addEventListener('click', notifyButton.__popupOpenHandler);
        }
      } else {
        notifyButton.removeAttribute('data-popup-open');

        if (notifyButton.__popupOpenHandler) {
          notifyButton.removeEventListener('click', notifyButton.__popupOpenHandler);
          delete notifyButton.__popupOpenHandler;
        }
      }
    };

    const getVariantFromSection = (section) => {
      const productJsonEl = section.querySelector(selectors.productJson);
      const variantIdInput = section.querySelector(selectors.variantIdInput);
      if (!productJsonEl || !variantIdInput) return null;

      const variantId = parseInt(variantIdInput.value, 10);
      if (!variantId) return null;

      try {
        const productJSON = JSON.parse(productJsonEl.innerHTML);
        return productJSON.variants.find((v) => v.id === variantId) || null;
      } catch (e) {
        return null;
      }
    };

    const init = () => {
      const sections = document.querySelectorAll(
        `${selectors.productSection}, ${selectors.quickAddModal}`
      );

      sections.forEach((section) => {
        const variant = getVariantFromSection(section);
        updateNotifyPopupTrigger(section, variant);
      });

      document.addEventListener('theme:variant:change', (e) => {
        const section = e.target.closest(selectors.productSection)
          || e.target.closest(selectors.quickAddModal);
        if (!section) return;
        updateNotifyPopupTrigger(section, e.detail?.variant);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  /**
   * Variant Availability Fix
   * Prevents options from being marked as sold-out/unavailable when other options aren't selected yet.
   * Each option should show its true availability based on whether ANY variant with that option is available.
   */
  class VariantAvailabilityFix {
    constructor() {
      this.selectors = {
        productSection: '[data-section-type="product"]',
        productJson: '[data-product-json]',
        variantSelectors: '[data-product-variants]',
        selectorWrapper: '.selector-wrapper',
        optionPosition: 'data-option-position',
        optionInput: '[data-single-option-selector]',
        radioButton: '.radio__button input[type="radio"]',
        swatchButton: '.swatch__button input[type="radio"]',
        popoutOption: '[data-popout-option]',
        popoutInput: '[data-popout-input]'
      };

      this.classes = {
        soldOut: 'sold-out',
        unavailable: 'unavailable'
      };

      this.init();
    }

    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }

    setup() {
      const productSections = document.querySelectorAll(this.selectors.productSection);
      productSections.forEach(section => this.initProductSection(section));

      // Observe for dynamically added products
      this.observeNewProducts();
    }

    initProductSection(section) {
      const productJsonEl = section.querySelector(this.selectors.productJson);
      const variantSelectors = section.querySelector(this.selectors.variantSelectors);

      if (!productJsonEl || !variantSelectors) return;

      let productJSON;
      try {
        productJSON = JSON.parse(productJsonEl.innerHTML);
      } catch (e) {
        console.warn('Could not parse product JSON for availability fix');
        return;
      }

      const state = {
        section,
        productJSON,
        variantSelectors
      };

      // Run initial availability check
      this.updateAvailability(state);

      // Listen for option changes to re-run availability check
      variantSelectors.addEventListener('change', () => {
        // Delay slightly to let the theme's SelloutVariants run first
        setTimeout(() => this.updateAvailability(state), 50);
      });

      // Also listen for popout clicks
      variantSelectors.addEventListener('click', (e) => {
        if (e.target.closest(this.selectors.popoutOption)) {
          setTimeout(() => this.updateAvailability(state), 100);
        }
      });
    }

    updateAvailability(state) {
      const { section, productJSON, variantSelectors } = state;

      // Get current selections
      const currentSelections = this.getCurrentSelections(variantSelectors);

      // Get all option wrappers
      const selectorWrappers = variantSelectors.querySelectorAll(this.selectors.selectorWrapper);

      selectorWrappers.forEach((wrapper) => {
        const positionAttr = wrapper.getAttribute(this.selectors.optionPosition);
        if (!positionAttr) return;

        const position = parseInt(positionAttr, 10) - 1; // Convert to 0-indexed

        // Get all option inputs in this wrapper
        const radioInputs = wrapper.querySelectorAll('input[type="radio"]');
        const popoutOptions = wrapper.querySelectorAll(this.selectors.popoutOption);

        // Check availability for each option value
        radioInputs.forEach(input => {
          const value = input.value;
          const availability = this.getOptionAvailability(productJSON, position, value, currentSelections);
          this.updateInputClasses(input, availability);
        });

        popoutOptions.forEach(option => {
          const value = option.getAttribute('data-value');
          const availability = this.getOptionAvailability(productJSON, position, value, currentSelections);
          this.updatePopoutClasses(option, availability);
        });
      });
    }

    getCurrentSelections(variantSelectors) {
      const selections = {};
      const wrappers = variantSelectors.querySelectorAll(this.selectors.selectorWrapper);

      wrappers.forEach((wrapper) => {
        const positionAttr = wrapper.getAttribute(this.selectors.optionPosition);
        if (!positionAttr) return;

        const position = parseInt(positionAttr, 10) - 1;

        // Check for checked radio
        const checkedRadio = wrapper.querySelector('input[type="radio"]:checked');
        if (checkedRadio && checkedRadio.value) {
          selections[position] = checkedRadio.value;
          return;
        }

        // Check for popout hidden input with value
        const popoutInput = wrapper.querySelector(this.selectors.popoutInput);
        if (popoutInput && popoutInput.value && popoutInput.value.trim() !== '') {
          selections[position] = popoutInput.value;
        }
      });

      return selections;
    }

    getOptionAvailability(productJSON, optionPosition, optionValue, currentSelections) {
      // Find all variants that have this option value at this position
      const matchingVariants = productJSON.variants.filter(variant => {
        // Must match this option value
        if (variant.options[optionPosition] !== optionValue) {
          return false;
        }

        // Must also match any OTHER currently selected options
        for (const [pos, val] of Object.entries(currentSelections)) {
          const posInt = parseInt(pos, 10);
          // Skip the current option position we're checking
          if (posInt === optionPosition) continue;
          // Check if this variant matches the selected value at other positions
          if (variant.options[posInt] !== val) {
            return false;
          }
        }

        return true;
      });

      // If no matching variants exist, it's unavailable (invalid combination)
      if (matchingVariants.length === 0) {
        return 'unavailable';
      }

      // If all matching variants are out of stock, it's sold out
      const hasAvailable = matchingVariants.some(v => v.available);
      if (!hasAvailable) {
        return 'sold-out';
      }

      // Otherwise it's available
      return 'available';
    }

    updateInputClasses(input, availability) {
      input.classList.remove(this.classes.soldOut, this.classes.unavailable);

      if (availability === 'unavailable') {
        input.classList.add(this.classes.unavailable);
      } else if (availability === 'sold-out') {
        input.classList.add(this.classes.soldOut);
      }
    }

    updatePopoutClasses(option, availability) {
      const popout = option.closest('[data-popout]');

      option.classList.remove(this.classes.soldOut, this.classes.unavailable);
      if (popout) {
        popout.classList.remove(this.classes.soldOut, this.classes.unavailable);
      }

      if (availability === 'unavailable') {
        option.classList.add(this.classes.unavailable);
        if (popout) popout.classList.add(this.classes.unavailable);
      } else if (availability === 'sold-out') {
        option.classList.add(this.classes.soldOut);
        if (popout) popout.classList.add(this.classes.soldOut);
      }
    }

    observeNewProducts() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              // Handle standard product sections
              const productSection = node.matches?.(this.selectors.productSection)
                ? node
                : node.querySelector?.(this.selectors.productSection);

              if (productSection) {
                // Delay to let theme initialize first
                setTimeout(() => this.initProductSection(productSection), 100);
              }

              // Handle quick add modals — the [data-api-content] wrapper is stripped during
              // modal creation (only its innerHTML is inserted into [data-product-upsell-ajax]),
              // so we detect [data-product-variants] being added and walk up to the dialog.
              const variantSelectorsNode = node.matches?.(this.selectors.variantSelectors)
                ? node
                : node.querySelector?.(this.selectors.variantSelectors);

              if (variantSelectorsNode) {
                const quickAddModal = variantSelectorsNode.closest('[data-quick-add-modal]');
                if (quickAddModal) {
                  setTimeout(() => this.initProductSection(quickAddModal), 100);
                }
              }
            }
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  // Initialize the availability fix
  new VariantAvailabilityFix();

})();

// Re-init infinite scroll after filter/sort updates products grid
(function() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target.matches('[data-products-grid]')) {
        // Products grid was updated, re-init infinite scroll if available
        if (window.initInfiniteScroll) {
          window.initInfiniteScroll();
        }
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      const grid = document.querySelector('[data-products-grid]');
      if (grid) {
        observer.observe(grid, { childList: true, subtree: false });
      }
    });
  } else {
    const grid = document.querySelector('[data-products-grid]');
    if (grid) {
      observer.observe(grid, { childList: true, subtree: false });
    }
  }
})();

(function() {
  function initUpsellSliders() {
    document.querySelectorAll('[data-upsell-drag-scroll]').forEach(function(slider) {
      if (slider._upsellDragInit) return;
      slider._upsellDragInit = true;

      var isDown = false;
      var isDragging = false;
      var wasDragging = false;
      var startX = 0;
      var startScrollLeft = 0;
      var velX = 0;
      var lastX = 0;
      var lastTime = 0;
      var animRaf = null;

      function getSlideWidth() {
        var slide = slider.querySelector('[data-slide]');
        if (!slide) return 132;
        var gap = parseFloat(getComputedStyle(slider).gap) || 12;
        return slide.offsetWidth + gap;
      }

      function snapToNearestSlide() {
        if (animRaf) cancelAnimationFrame(animRaf);

        var slideWidth = getSlideWidth();
        // Project where scroll would coast to based on velocity
        var projected = slider.scrollLeft - velX * 180;
        var slides = slider.querySelectorAll('[data-slide]');
        var targetIndex = Math.round(projected / slideWidth);
        targetIndex = Math.max(0, Math.min(targetIndex, slides.length - 1));
        var targetPos = targetIndex * slideWidth;

        var startPos = slider.scrollLeft;
        var distance = targetPos - startPos;
        var duration = 320;
        var startTime = null;

        function step(timestamp) {
          if (!startTime) startTime = timestamp;
          var elapsed = timestamp - startTime;
          var t = Math.min(elapsed / duration, 1);
          // ease-out cubic
          var ease = 1 - Math.pow(1 - t, 3);
          slider.scrollLeft = startPos + distance * ease;
          if (t < 1) {
            animRaf = requestAnimationFrame(step);
          } else {
            slider.classList.remove('is-dragging');
          }
        }

        animRaf = requestAnimationFrame(step);
      }

      slider.addEventListener('mousedown', function(e) {
        isDown = true;
        isDragging = false;
        if (animRaf) cancelAnimationFrame(animRaf);
        startX = e.pageX - slider.offsetLeft;
        startScrollLeft = slider.scrollLeft;
        velX = 0;
        lastX = e.pageX;
        lastTime = performance.now();
      });

      slider.addEventListener('mouseleave', function() {
        if (!isDown) return;
        isDown = false;
        if (isDragging) {
          isDragging = false;
          snapToNearestSlide();
        }
      });

      slider.addEventListener('mouseup', function() {
        if (!isDown) return;
        isDown = false;
        if (isDragging) {
          isDragging = false;
          snapToNearestSlide();
        }
        if (wasDragging) {
          wasDragging = false;
          slider.addEventListener('click', function blockClick(e) {
            e.stopPropagation();
            e.preventDefault();
            slider.removeEventListener('click', blockClick, true);
          }, true);
        }
      });

      slider.addEventListener('touchstart', function(e) {
        isDown = true;
        isDragging = false;
        if (animRaf) cancelAnimationFrame(animRaf);
        startX = e.touches[0].pageX - slider.offsetLeft;
        startScrollLeft = slider.scrollLeft;
        velX = 0;
        lastX = e.touches[0].pageX;
        lastTime = performance.now();
      }, { passive: true });

      slider.addEventListener('touchmove', function(e) {
        if (!isDown) return;
        var x = e.touches[0].pageX - slider.offsetLeft;
        var walk = (x - startX) * 2;
        if (!isDragging && Math.abs(walk) > 5) {
          isDragging = true;
          wasDragging = true;
          slider.classList.add('is-dragging');
        }
        if (!isDragging) return;
        var now = performance.now();
        var dt = now - lastTime;
        if (dt > 0) velX = (e.touches[0].pageX - lastX) / dt;
        lastX = e.touches[0].pageX;
        lastTime = now;
        slider.scrollLeft = startScrollLeft - walk;
      }, { passive: true });

      slider.addEventListener('touchend', function() {
        if (!isDown) return;
        isDown = false;
        if (isDragging) {
          isDragging = false;
          snapToNearestSlide();
        }
        if (wasDragging) {
          wasDragging = false;
          slider.addEventListener('click', function blockClick(e) {
            e.stopPropagation();
            e.preventDefault();
            slider.removeEventListener('click', blockClick, true);
          }, true);
        }
      });

      slider.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        var x = e.pageX - slider.offsetLeft;
        var walk = (x - startX) * 2;
        if (!isDragging && Math.abs(walk) > 5) {
          isDragging = true;
          wasDragging = true;
          slider.classList.add('is-dragging');
        }
        if (!isDragging) return;
        e.preventDefault();
        var now = performance.now();
        var dt = now - lastTime;
        if (dt > 0) velX = (e.pageX - lastX) / dt;
        lastX = e.pageX;
        lastTime = now;
        slider.scrollLeft = startScrollLeft - walk;
      });

      slider.addEventListener('dragstart', function(e) {
        e.preventDefault();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpsellSliders);
  } else {
    initUpsellSliders();
  }

  document.addEventListener('theme:cart:change', function() { setTimeout(initUpsellSliders, 150); });
  document.addEventListener('theme:cart-drawer:open', function() { setTimeout(initUpsellSliders, 150); });
})();

// Size Inventory Status Updater
(function() {
  class SizeInventoryUpdater {
    constructor() {
      this.selectors = {
        productSection: '[data-section-type="product"]',
        productJson: '[data-product-json]',
        inventoryStatus: '[data-size-inventory]',
        inventoryIn: '.size-inventory--in',
        inventoryLow: '.size-inventory--low',
        inventoryOut: '.size-inventory--out',
        inventoryCount: '[data-inventory-count]',
        variantIdInput: 'input[name="id"]'
      };
      this.init();
    }

    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }

    setup() {
      const productSections = document.querySelectorAll(this.selectors.productSection);
      productSections.forEach(section => this.initSection(section));

      // Listen for theme variant change events
      document.addEventListener('theme:variant:change', (e) => {
        const section = e.target.closest(this.selectors.productSection);
        if (section) {
          this.updateInventory(section, e.detail?.variant);
        }
      });
    }

    initSection(section) {
      const inventoryEl = section.querySelector(this.selectors.inventoryStatus);
      if (!inventoryEl) return;

      const productJsonEl = section.querySelector(this.selectors.productJson);
      if (!productJsonEl) return;

      let productJSON;
      try {
        productJSON = JSON.parse(productJsonEl.innerHTML);
      } catch (e) {
        return;
      }

      // Store product data
      inventoryEl.productData = productJSON;

      // Listen for variant input changes
      const variantInput = section.querySelector(this.selectors.variantIdInput);
      if (variantInput) {
        const observer = new MutationObserver(() => {
          const variantId = parseInt(variantInput.value, 10);
          const variant = productJSON.variants.find(v => v.id === variantId);
          if (variant) {
            this.updateInventory(section, variant);
          }
        });
        observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });

        // Also listen for change events
        variantInput.addEventListener('change', () => {
          const variantId = parseInt(variantInput.value, 10);
          const variant = productJSON.variants.find(v => v.id === variantId);
          if (variant) {
            this.updateInventory(section, variant);
          }
        });
      }
    }

    updateInventory(section, variant) {
      const inventoryEl = section.querySelector(this.selectors.inventoryStatus);
      if (!inventoryEl || !variant) return;

      const threshold = parseInt(inventoryEl.dataset.lowThreshold, 10) || 10;
      const inEl = inventoryEl.querySelector(this.selectors.inventoryIn);
      const lowEl = inventoryEl.querySelector(this.selectors.inventoryLow);
      const outEl = inventoryEl.querySelector(this.selectors.inventoryOut);
      const countEl = inventoryEl.querySelector(this.selectors.inventoryCount);

      // Hide all first
      if (inEl) inEl.style.display = 'none';
      if (lowEl) lowEl.style.display = 'none';
      if (outEl) outEl.style.display = 'none';

      // Check if inventory is tracked
      if (!variant.inventory_management || variant.inventory_policy !== 'deny') {
        inventoryEl.style.display = 'none';
        return;
      }

      inventoryEl.style.display = '';
      const qty = variant.inventory_quantity;

      if (qty <= 0) {
        if (outEl) outEl.style.display = 'flex';
      } else if (qty <= threshold) {
        if (lowEl) lowEl.style.display = 'flex';
        if (countEl) countEl.textContent = qty;
      } else {
        if (inEl) inEl.style.display = 'flex';
      }
    }
  }

  new SizeInventoryUpdater();
})();

// Product Accordion - Single Open Behavior
// Only one accordion open at a time across ALL .product-accordion elements on the page
(function() {
  function initProductAccordions() {
    // Get all details elements inside .product-accordion containers
    const allAccordionDetails = document.querySelectorAll('.product-accordion details');

    allAccordionDetails.forEach(details => {
      // Skip if already initialized
      if (details.dataset.singleOpenInit === 'true') return;
      details.dataset.singleOpenInit = 'true';

      details.addEventListener('toggle', function() {
        // Only act when opening
        if (!this.open) return;

        // Close all other open accordions across the entire page
        allAccordionDetails.forEach(otherDetails => {
          if (otherDetails !== this && otherDetails.open) {
            otherDetails.removeAttribute('open');

            // Also reset the collapsible body height for smooth animation
            const body = otherDetails.querySelector('[data-collapsible-body]');
            if (body) {
              body.style.height = '0px';
            }
          }
        });
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductAccordions);
  } else {
    initProductAccordions();
  }

  // Re-initialize when sections are loaded (for Shopify section rendering)
  document.addEventListener('shopify:section:load', initProductAccordions);

  // Observe for dynamically added accordions
  const accordionObserver = new MutationObserver((mutations) => {
    let shouldInit = false;
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.classList?.contains('product-accordion') || node.querySelector?.('.product-accordion')) {
            shouldInit = true;
          }
        }
      });
    });
    if (shouldInit) {
      initProductAccordions();
    }
  });

  accordionObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();





(function() {

  class ProductCardSwatches {
    constructor() {
      this.selectors = {
        container: '[data-swatches-container]',
        moreButton: '[data-swatches-more]'
      };
      this.expandedClass = 'is-expanded';
      this.collapseTimers = new WeakMap();
      this.mobileBreakpoint = 990;
      this.init();
    }

    init() {
    
      this.bindEvents();
      this.updateAllContainersVisibility();
    }

    isMobile() {
      return window.innerWidth < this.mobileBreakpoint;
    }

    updateAllContainersVisibility() {
      const containers = document.querySelectorAll(this.selectors.container);
      containers.forEach(container => this.updateContainerVisibility(container));
    }

    updateContainerVisibility(container) {
      const isMobile = this.isMobile();
      const overflowDesktop = parseInt(container.dataset.overflowDesktop || '0', 10);
      const overflowMobile = parseInt(container.dataset.overflowMobile || '0', 10);
      const hasOverflow = isMobile ? overflowMobile > 0 : overflowDesktop > 0;


      if (hasOverflow) {
        container.classList.add('has-overflow');
      } else {
        container.classList.remove('has-overflow');
        container.classList.remove(this.expandedClass);
      }
    }

    bindEvents() {
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.updateAllContainersVisibility();
        }, 100);
      });


      document.addEventListener('mouseenter', (event) => {
        if (!event.target || !event.target.closest) return;

        const moreButton = event.target.closest(this.selectors.moreButton);
        if (moreButton) {
          const container = moreButton.closest(this.selectors.container);
          if (container) {
            this.clearCollapseTimer(container);
          }
          return;
        }

        const swatch = event.target.closest('.product-swatch');
        if (swatch) {
          const container = swatch.closest(this.selectors.container);
          if (container) {
            this.clearCollapseTimer(container);
          }
        }
      }, true);

      document.addEventListener('mouseleave', (event) => {
        if (!event.target || !event.target.closest) return;

        const container = event.target.closest(this.selectors.container);
        if (container && container.classList.contains(this.expandedClass)) {
          this.setCollapseTimer(container);
        }
      }, true);

      // Handle click events (works for desktop and some mobile)
      document.addEventListener('click', (event) => {
        if (!event.target || !event.target.closest) return;

        const moreButton = event.target.closest(this.selectors.moreButton);
        if (moreButton) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          const container = moreButton.closest(this.selectors.container);
          if (container) {
            this.expandSwatches(container);
          }
          return;
        }
      }, true);

      // Handle touch events for mobile - this catches touches before they become clicks
      document.addEventListener('touchend', (event) => {
        if (!event.target || !event.target.closest) return;

        // Handle +N button touch
        const moreButton = event.target.closest(this.selectors.moreButton);
        if (moreButton) {
          event.preventDefault();
          event.stopPropagation();
          const container = moreButton.closest(this.selectors.container);
          if (container) {
            this.expandSwatches(container);
          }
          return;
        }
      }, { capture: true, passive: false });
    }

    setCollapseTimer(container) {
      this.clearCollapseTimer(container);
      const timer = setTimeout(() => {
        this.collapseSwatches(container);
      }, 300);
      this.collapseTimers.set(container, timer);
    }

    clearCollapseTimer(container) {
      const timer = this.collapseTimers.get(container);
      if (timer) {
        clearTimeout(timer);
        this.collapseTimers.delete(container);
      }
    }

    expandSwatches(container) {
      container.classList.add(this.expandedClass);
    }

    collapseSwatches(container) {
      container.classList.remove(this.expandedClass);
    }
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ProductCardSwatches());
  } else {
    new ProductCardSwatches();
  }


})();

class productImagesSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.swiperContainer = null;
  }

  connectedCallback() {
    this.swiperContainer = this.querySelector('.swiper');
    if (!this.swiperContainer || typeof Swiper === 'undefined') return;

    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  initSwiper() {
    if (!this.swiperContainer) return;

    const isUpsellCard = this.classList.contains('product-upsell__carousel');
    const prevBtn =
      this.querySelector('[data-button-prev]') ||
      this.querySelector('.swiper-button-prev');
    const nextBtn =
      this.querySelector('[data-button-next]') ||
      this.querySelector('.swiper-button-next');
    const hasInlineNavigation = Boolean(prevBtn && nextBtn);
    const slides = Array.from(this.swiperContainer.querySelectorAll('.swiper-slide'));
    const activeSlideIndex = slides.findIndex((slide) => slide.classList.contains('media--active'));
    const shouldUseNavigation = isUpsellCard || hasInlineNavigation;

    if (this.swiper) {
      this.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(this.swiperContainer, {
      slidesPerView: 'auto',
      watchOverflow: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      initialSlide: activeSlideIndex > -1 ? activeSlideIndex : 0,
      loop: shouldUseNavigation && slides.length > 1,
      ...(shouldUseNavigation
        ? {
            navigation: {
              prevEl: prevBtn,
              nextEl: nextBtn,
            },
          }
        : {
            spaceBetween: 8,
            mousewheel: {
              forceToAxis: true,
            },
          }),
    });

    requestAnimationFrame(() => {
      if (!this.swiper) return;
      this.swiper.update();
    });
  }
}

customElements.define('product-images-swiper', productImagesSwiper);     

// Reopen side cart after quick add modal is dismissed
(function () {

  // STEP 1: Detect theme:quick-add:open so we know a quick add was triggered
  document.addEventListener('theme:quick-add:open', () => {
    const cartDrawer = document.querySelector('cart-drawer');
    // Do not close the search popdown here — quick-add can open from inside predictive search.
  });

  // STEP 2: Detect cart drawer closing
  document.addEventListener('theme:cart-drawer:close', () => {
    // All [data-quick-add-modal] elements (inert or not)
    const allModals = document.querySelectorAll('[data-quick-add-modal]');

    const quickAddModal = document.querySelector('[data-quick-add-modal]:not([inert])');

    if (!quickAddModal) {
      console.log('[QuickAdd->Cart] No open quick-add modal found — cart closed for another reason, skipping');
      return;
    }

    // STEP 3: Watch for the modal's inert attribute to be restored (modal fully closed)
    const obs = new MutationObserver((mutations) => {

      if (!quickAddModal.hasAttribute('inert')) {
        console.log('[QuickAdd->Cart] Modal still not inert — waiting');
        return;
      }

      obs.disconnect();

      setTimeout(() => {
        const cartDrawer = document.querySelector('cart-drawer');

        if (cartDrawer && !cartDrawer.cartDrawerIsOpen) {
          cartDrawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show', { bubbles: true }));
        } 
      }, 150);
    });

    obs.observe(quickAddModal, { attributes: true, attributeFilter: ['inert'] });
  });
})();


class SvgImage extends HTMLElement {
  connectedCallback() {
    this.convertImage();
  }

  convertImage() {
    const mainDiv = this.querySelector(".icon-svg__image");
    console.log(mainDiv,"mainDivmainDiv");
    
    if (!mainDiv) return;

    const imageUrl = mainDiv.getAttribute("data-image-url");

    if (imageUrl) {
      fetch(imageUrl)
        .then((response) => {
          if (!response.ok) throw new Error("Network response was not ok");
          return response.text();
        })
        .then((svgText) => {
          mainDiv.innerHTML = svgText;
        })
        .catch((error) => {
          console.error("Error fetching SVG:", error);
        });
    }
  }
}

customElements.define("svg-image", SvgImage);

// Cart full availability notification — show inventory message only after ATC fails (inventory maxed in cart)
(function () {
  // After a failed add — Shopify 422 means all inventory is already in cart
  document.addEventListener('theme:product:add-error', function () {
    document.querySelectorAll('[data-remaining-wrapper]').forEach(function (wrapper) {
      wrapper.setAttribute('data-show-cart-full', 'true');
    });
  });

  // Reset when user changes variant option
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-single-option-selector], [data-popout-input]')) {
      document.querySelectorAll('[data-remaining-wrapper][data-show-cart-full]').forEach(function (w) {
        w.removeAttribute('data-show-cart-full');
      });
    }
  });
})();

// Direct cart count updater — updates every <cart-count> element on theme:cart:change
(function () {
  function updateAllCartCounts(count) {
    document.querySelectorAll('cart-count').forEach(function (el) {
      el.setAttribute('data-cart-count', count);
      el.textContent = count;
    });
  }

  document.addEventListener('theme:cart:change', function (e) {
    if (e && e.detail && e.detail.cart) {
      // Full cart object present (from custom.js) — always accurate, includes free gifts
      updateAllCartCounts(e.detail.cart.item_count);
    } else {
      // Count came from CartItems.build() via DOM input sum — misses free gift items
      // (free gifts have no <input name="updates[]"> in the template)
      // Fetch real count from Shopify to stay accurate
      fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateAllCartCounts(cart.item_count); })
        .catch(function () {
          if (e.detail && e.detail.cartCount != null) {
            updateAllCartCounts(e.detail.cartCount);
          }
        });
    }
  });
})();

// Measure actual announcement bar height and expose as --announcement-height CSS variable.
// This overrides the Liquid-computed CSS max() expression which can resolve to 0
// when font variables aren't available at parse time.
(function () {
  function setAnnouncementHeight() {
    const el = document.querySelector('[data-announcement-wrapper]');
    const height = el ? el.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-height', height + 'px');
  }

  document.addEventListener('DOMContentLoaded', setAnnouncementHeight);
  document.addEventListener('shopify:section:load', setAnnouncementHeight);
  window.addEventListener('resize', setAnnouncementHeight);
})();

// Suppress swiper nav arrows during swatch hover
(function() {
  const style = document.createElement('style');
  style.textContent = 'product-card .product-item__bg--hover.swatch-hover-active .swiper-button-next, product-card .product-item__bg--hover.swatch-hover-active .swiper-button-prev { opacity: 0 !important; pointer-events: none !important; } product-card .product-item__bg--hover.swatch-hover-active .swiper-wrapper { opacity: 0 !important; }';
  document.head.appendChild(style);
})();

// ProductCard custom element
if (!customElements.get('product-card')) {
  const isMobile = () => window.matchMedia('(max-width: 989px)').matches;

  // Global: only one card shows nav at a time
  let _activeCard = null;

  // Single document-level touchstart listener — always mounted
  document.addEventListener('touchstart', (e) => {
    if (!_activeCard || !isMobile()) return;
    // reset if touch is outside the active card's swiper image area
    if (!_activeCard._hoverEl.contains(e.target)) {
      _activeCard._hideNav();
    }
  }, { capture: true, passive: true });

  class ProductCard extends HTMLElement {
    connectedCallback() {
      this._defaultEl = this.querySelector('[data-product-image-default]');
      this._hoverEl   = this.querySelector('[data-product-image-hover]');
      this._swiperEl  = this.querySelector('[data-product-swiper]');
      this._navShown  = false;

      this._imageEl = this.querySelector('[data-product-image]');

      if (!this._hoverEl || !this._swiperEl) return;

      this._initSwiper();
      const target = this._imageEl || this;
      target.addEventListener('mouseenter', this._onEnter.bind(this));
      target.addEventListener('mouseleave', this._onLeave.bind(this));

      this._bindSwatchHover();
    }

    _bindSwatchHover() {
      if (window.matchMedia('(hover: none)').matches) return;
      const hoverEl = this._hoverEl;
      if (!hoverEl) return;

      // Create a dedicated swatch image layer inside the hover panel
      if (!this._swatchHoverImg) {
        this._swatchHoverImg = document.createElement('img');
        this._swatchHoverImg.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:10;';
        hoverEl.appendChild(this._swatchHoverImg);
      }

      const swatches = this.querySelectorAll('.product-swatch--link[data-hover-image], .product-swatch--current[data-hover-image]');

      // Preload all swatch images so hover is instant
      swatches.forEach(swatch => {
        const url = swatch.dataset.hoverImage;
        if (url) {
          const pre = new Image();
          pre.src = url;
        }
      });

      swatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', () => {
          const hoverImg = swatch.dataset.hoverImage;
          if (!hoverImg) return;
          if (this._swatchLeaveTimer) { clearTimeout(this._swatchLeaveTimer); this._swatchLeaveTimer = null; }
          this._swatchHovering = true;
          this._swatchHoverImg.src = hoverImg;
          this._swatchHoverImg.style.display = 'block';
          if (this._defaultEl) this._defaultEl.classList.add('is-hidden');
          hoverEl.classList.add('is-active');
          hoverEl.classList.add('swatch-hover-active');
        });
        swatch.addEventListener('mouseleave', () => {
          this._swatchLeaveTimer = setTimeout(() => {
            this._swatchHovering = false;
            this._swatchHoverImg.style.display = 'none';
            this._swatchHoverImg.src = '';
            if (this._defaultEl) this._defaultEl.classList.remove('is-hidden');
            hoverEl.classList.remove('is-active');
            hoverEl.classList.remove('swatch-hover-active');
            this._swatchLeaveTimer = null;
          }, 100);
        });
      });
    }

    disconnectedCallback() {
      if (_activeCard === this) _activeCard = null;
      if (this._swiper) { this._swiper.destroy(true, true); this._swiper = null; }
    }

    _initSwiper() {
      if (this._swiper || typeof Swiper === 'undefined') return;

      this._swiper = new Swiper(this._swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        observer: true,
        observeParents: true,
        a11y: false,
        focusableElements: 'nothing',
        navigation: {
          nextEl: this._swiperEl.querySelector('.swiper-button-next'),
          prevEl: this._swiperEl.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          0: {
            // mobile
            allowTouchMove: true,
            touchRatio: 1,
            touchAngle: 45,
            threshold: 5,
            grabCursor: false,
            speed: 300,
          },
          990: {
            // desktop
            allowTouchMove: false,
            touchRatio: 0,
            threshold: 0,
            grabCursor: false,
            speed: 400,
          },
        },
      });

      this._swiper.on('slideChange', () => {
        if (!isMobile() || this._resetting) return;
        if (_activeCard && _activeCard !== this) _activeCard._hideNav();
        _activeCard = this;
        this._navShown = true;
        this._hoverEl.classList.add('nav-visible');
      });
    }

    _hideNav() {
      this._resetting = true;
      this._navShown = false;
      this._hoverEl.classList.remove('nav-visible');
      if (_activeCard === this) _activeCard = null;
      if (this._swiper) {
        this._swiper.slideToLoop(1, 0);
        // clear flag after Swiper finishes the transition
        setTimeout(() => { this._resetting = false; }, 350);
      } else {
        this._resetting = false;
      }
    }

    // Desktop only
    _onEnter() {
      if (isMobile()) return;
      if (this._swatchHovering || this._hoverEl.classList.contains('swatch-hover-active')) return;
      // Cancel any in-progress reset and snap to hover slide instantly
      this._resetting = false;
      if (this._swiper) this._swiper.slideToLoop(1, 0);
      if (this._defaultEl) this._defaultEl.classList.add('is-hidden');
      this._hoverEl.classList.add('is-active');
    }

    _onLeave() {
      if (isMobile()) return;
      if (this._swatchHovering || this._hoverEl.classList.contains('swatch-hover-active')) return;
      if (this._defaultEl) this._defaultEl.classList.remove('is-hidden');
      this._hoverEl.classList.remove('is-active');
    }
  }

  customElements.define('product-card', ProductCard);
}

// Live-update transparent header when hero "Header style" setting changes in editor
(function () {
  function updateTransparentHeader() {
    const firstOverlay = document.querySelector('.main-content > .shopify-section.section-overlay-header:first-of-type');
    const enable = firstOverlay && !firstOverlay.querySelector('[data-prevent-transparent-header]');
    document.body.classList.toggle('has-first-section-overlay-header', !!enable);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.classList.contains('section-overlay-header') || e.target.querySelector('[data-overlay-header], [data-prevent-transparent-header]')) {
      updateTransparentHeader();
    }
  });
})();

// Keep predictive search open while quick-add modal is open.
// Approach: patch close() and closeResults() directly on the instance so they no-op
// while quick-add is pending or open — bypasses any focusout/event interception issues.
(function () {
  let quickAddPending = false;
  let quickAddOpen = false;

  // Set flag on mousedown — fires before focus moves, before fetch.
  document.addEventListener('mousedown', (e) => {
    const btn = e.target.closest('[data-quick-add-btn], [data-quick-add-modal-handle]');
    if (!btn) return;
    const inSearch = btn.closest('[data-popdown], predictive-search, #shopify-section-predictive-search');
    if (inSearch) quickAddPending = true;
  }, true);

  document.addEventListener('theme:quick-add:open', () => {
    quickAddPending = false;
    quickAddOpen = true;
  });

  // Watch for modal close.
  // modalClose() calls a11y.removeTrapFocus() which destroys the shared trapFocusHandlers —
  // this kills the search popdown's focus trap too. Re-trap on popdown after modal closes.
  const observer = new MutationObserver(() => {
    if (!quickAddOpen) return;
    const hasOpenModal = !!document.querySelector('[data-quick-add-modal][open]:not([inert])');
    if (!hasOpenModal) {
      // Re-trap focus on search popdown so focus stays contained and onFocusOut doesn't fire.
      setTimeout(() => {
        const popdown = document.querySelector('[data-popdown]');
        const input = popdown && popdown.querySelector('input[type="search"]');
        if (popdown && input && window.theme && window.theme.a11y) {
          window.theme.a11y.trapFocus(popdown, { elementToFocus: input });
        }
        quickAddOpen = false;
      }, 50);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'inert'] });

  function patchInstance(el) {
    const origClose = el.close.bind(el);
    const origCloseResults = el.closeResults.bind(el);

    el.close = function (clearSearchTerm = false) {
      if (quickAddPending || quickAddOpen) return;
      origClose(clearSearchTerm);
    };

    el.closeResults = function (clearSearchTerm = false) {
      if (quickAddPending || quickAddOpen) return;
      origCloseResults(clearSearchTerm);
    };
  }

  customElements.whenDefined('predictive-search').then(() => {
    document.querySelectorAll('predictive-search').forEach(patchInstance);

    const PredictiveSearchClass = customElements.get('predictive-search');
    if (!PredictiveSearchClass) return;
    const origConnected = PredictiveSearchClass.prototype.connectedCallback;
    PredictiveSearchClass.prototype.connectedCallback = function () {
      origConnected.call(this);
      patchInstance(this);
    };
  });

  // Also guard SearchPopdown.close() — it hides the entire dropdown visually.
  customElements.whenDefined('header-search-popdown').then(() => {
    const SearchPopdownClass = customElements.get('header-search-popdown');
    if (!SearchPopdownClass) return;

    const origPopdownClose = SearchPopdownClass.prototype.close;
    SearchPopdownClass.prototype.close = function () {
      if (quickAddPending || quickAddOpen) return;
      origPopdownClose.call(this);
    };
  });
})();
